export default "__VITE_PUBLIC_ASSET__c6d2b04c__"